// @flow
import { completeLoginModal, OPEN_LOGIN_MODAL } from './modal';
import { createSelector } from 'reselect';
import { fetchUpcomingBidderBiddingIfNeeded } from './bidderBiddingInfoUpcoming';
import { getDeployment } from './config';
import { getLoginAnalytics } from './analytics';
import type { GlobalState } from '../rootReducer';
import { OPEN_LOGIN_MODAL_FROM_CHECKER } from './shouldLogin';
import { postLogin } from '../api/bidder';

/* Action Types */
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

/* reducer */
const DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOGIN_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false,
            };
        case LOGIN_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: true,
                success: false,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case OPEN_LOGIN_MODAL:
        case OPEN_LOGIN_MODAL_FROM_CHECKER:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.login;

export const getUiLogin = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
const loginFail = (emailAddress, error) => ({
    error: true,
    meta: { emailAddress },
    payload: error,
    type: LOGIN_FAIL,
});

const loginRequest = emailAddress => ({
    payload: emailAddress,
    type: LOGIN_REQUEST,
});

const loginSuccess = loginData => ({
    meta: { ...getLoginAnalytics(loginData), actionTime: Date.now() },
    payload: loginData,
    type: LOGIN_SUCCESS,
});

export const submitLogin = (emailAddress: ?string, password: ?string, mainhostLogin: any = {}) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        const username = emailAddress || mainhostLogin.authNuid;
        dispatch(loginRequest(username));

        const response = await postLogin({ deployment, mainhostLogin, password, username });
        await dispatch(completeLoginModal());
        await dispatch(
            loginSuccess({
                ...response.data,
                bidder: { ...response.data.bidder, ANMS: response.data.annualNMS },
            })
        );

        return Promise.all([dispatch(fetchUpcomingBidderBiddingIfNeeded())]);
    } catch (error) {
        dispatch(loginFail(emailAddress, error));
    }
};
